import { createFileRoute } from "@tanstack/react-router";

import { ForwardingIntegrationsContainer } from "@/features/settings/forwarding-integrations";

export const Route = createFileRoute(
  "/_authenticated/$company/unternehmen/_settings/einstellungen/weiterleitung",
)({
  component: Forwarding,
});

function Forwarding() {
  return <ForwardingIntegrationsContainer />;
}
